import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense";
import { useDashboardFilters } from "./dashboard-filters";
import useReturnRequestsTimeChart from "@babackapp/private-api-client/client/use-return-requests-time-chart";

export default function useCurrentFiltersReturnRequestsStats() {
  const { data: shop } = useCurrentShopSuspense();
  const {
    toTimestamp,
    fromTimestamp,
    productId,
    variantId,
    resolution,
    reason,
    sourceChannel,
  } = useDashboardFilters();

  return useReturnRequestsTimeChart(shop.id, {
    fromTimestamp: fromTimestamp ?? Date.now(),
    toTimestamp: toTimestamp ?? 0,
    productId,
    variantId,
    resolution,
    reason,
    sourceChannel,
  });
}
